<template>
    <span class="tracking-wider text-xs font-medium text-gray-700 pr-2">
        <slot></slot>
    </span>
</template>

<script setup>
</script>